import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';

@Component({
  selector: 'op-principal-loading-skeleton',
  templateUrl: './op-principal-loading-skeleton.component.html',
  styleUrls: ['./op-principal-loading-skeleton.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OpPrincipalLoadingComponent {

}
